import { domain, token } from "../../../../../components/Security";
import axios from "../../../../../api/apiClient";
import { useCallback, useEffect, useState } from "react";
import { SetPayrollPeriodId } from "../utils/SetPayrollPeriodId";

export function PayrollPeriodIdSelectFilter2({
	payrollPeriodId,
	setPayrollPeriodId,
	payTypeId,
	mainPayrollPeriod,
}) {
	const [isSelected, setIsSelected] = useState(false);

	const handleSelectChange = (event) => {
		setIsSelected(true);
		setPayrollPeriodId(event.target.value);
	};

	const [data, setData] = useState([]);

	const fetchData = useCallback(async () => {
		if (!payTypeId) {
			return;
		}
		// const currentYear = new Date().getFullYear();
		// const apiUrl =  domain + `/api/PayrollPeriod/year/${currentYear}`;
		const apiUrl =
			domain +
			`/api/PayrollPeriod/active/paytype/${payTypeId}/before/main-payrollperiod/${mainPayrollPeriod}`; // changed

		await axios
			.get(apiUrl, {
				headers: {
					Authorization: `Bearer ${token}`,
					"Content-Type": "application/json", // You can include other headers if needed
				},
			})
			.then((response) => {
				setData(response.data);
			})
			.catch((error) => {
				console.error("Error fetching data:", error);
			});
	}, [payTypeId, mainPayrollPeriod]);

	useEffect(() => {
		fetchData();
		if (payrollPeriodId !== "" && payrollPeriodId !== 0) {
			setIsSelected(true);
		} else {
			setIsSelected(false);
		}
	}, [fetchData, payrollPeriodId]);

	return (
		<div>
			<select
				id="employee-select-PagibigReport"
				disabled={!payTypeId}
				value={payrollPeriodId || ""}
				onChange={handleSelectChange}
				style={{
					color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)",
				}}
			>
				<option value="" disabled hidden>
					Choose payroll period
				</option>
				{data.map((payrollPeriodId) => SetPayrollPeriodId(payrollPeriodId))}
			</select>
		</div>
	);
}
